export default () => {
    return {
        mounted(scale = 1.25, shift = 25) {
            gsap.set(this.$refs.background, { scale: scale });
            gsap.fromTo(
                this.$refs.background,
                { yPercent: -shift },
                { yPercent: shift, ease: 'none', scrollTrigger: { trigger: this.$refs.container, scrub: true } }
            );
        }
    };
};
